import { render, staticRenderFns } from "./cmpConcussion.vue?vue&type=template&id=628fd0e6&"
import script from "./cmpConcussion.vue?vue&type=script&lang=js&"
export * from "./cmpConcussion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports